export const required = (v) => !!v || 'Поле має бути заповненим'

export const greateThan10 = (v) => v.length > 10

export const email = v => !v || /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || 'Не вірний формат електронної пошти'

export const phone = v => !v || v.replace(/\D/g, '').length === 10 || 'Не вірний формат телефону'
